import { resizeImageIfNeeded } from "@src/functions/resizeImageIfNeeded";
import { IContext, IMessage, ITypeAreaState } from "@src/types";
import { api, atom, injectCallback, injectEffect, injectStore } from "@zedux/react";

export const typeAreaAtom = atom("type_area", (context: IContext, topicId: number) => {
    const store = injectStore<ITypeAreaState>({
        typedText: "",
        imagePreview: null,
        fileData: null,
        editMode: null,
        replyMode: null,
    })

    const cleanUpImagePreview = injectCallback(() => {
        const { imagePreview } = store.getState()
        if (imagePreview) {
            URL.revokeObjectURL(imagePreview)
        }
    }, [])

    const setTypedText = injectCallback((text: string) => {
        console.log("Setting typed text:", topicId, text) // Debugging log
        store.setState((state) => ({ ...state, typedText: text }))
    }, [])

    const setImagePreview = injectCallback(async (preview: File | null) => {
        cleanUpImagePreview()

        if (preview !== null) {
            const processedFile = await resizeImageIfNeeded(preview)
            const nextPreview = URL.createObjectURL(processedFile)
            store.setState((state) => ({ ...state, imagePreview: nextPreview, fileData: processedFile }))
        } else {
            store.setState((state) => ({ ...state, imagePreview: null, fileData: null }))
        }
    }, [cleanUpImagePreview])

    // This function sets the file data and cleans up the image preview if necessary. It also resets the image preview to null when a new file is set.
    const setFileData = injectCallback((file: File | null) => {
        cleanUpImagePreview()
        store.setState((state) => ({ ...state, fileData: file, imagePreview: null }))
    }, [cleanUpImagePreview])


    const setEditMode = injectCallback((message: IMessage | null) => {
        store.setState((state) => ({ ...state, editMode: message, replyMode: null, typedText: message ? message.text : state.typedText }))
    }, [])


    const setReplyMode = injectCallback((message: IMessage | null) => {
        store.setState((state) => ({ ...state, replyMode: message, editMode: null }))
    }, [])


    // Cleanup effect to revoke the object URL when the component unmounts or when the image preview changes
    injectEffect(() => {
        return cleanUpImagePreview
    }, [])

    return api(store).setExports({
        setTypedText,
        setImagePreview,
        setFileData,
        setEditMode,
        setReplyMode,
    })
})


